// ICON PROPS TYPES
type IconProps = {
  size?: number;
  color?: string;
  width?: number;
  height?: number;
};

/**
 * ICON FOR COPY BUTTON
 * @param param0
 * @returns
 */
// region Copy Icon
export const CopyIcon = ({ size = 24, color = "#3B82F6" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6119_155"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={size}
        height={size}
      >
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6119_155)">
        <path
          d="M9 18C8.45 18 7 18 7 18C7 18 7 16.55 7 16V4C7 3.45 7 2 7 2C7 2 8.45 2 9 2H18C18.55 2 20 2 20 2C20 2 20 3.45 20 4V16C20 16.55 20 18 20 18C20 18 18.55 18 18 18H9ZM9 16H18V4H9V16ZM5 22C4.45 22 3 22 3 22C3 22 3 20.55 3 20V6H5V20H16V22H5Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

/**
 * CHECKED ICON
 * @param param0
 * @returns
 */
// region Checked Icon
export const CheckedIcon = ({ size = 11, color = "#00994D" }: IconProps) => {
  return (
    <svg
      width={size + 3}
      height={size}
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.95874 10.9998L0.20874 6.24984L1.39624 5.06234L4.95874 8.62484L12.6046 0.979004L13.7921 2.1665L4.95874 10.9998Z"
        fill={color}
      />
    </svg>
  );
};

/**
 * COPY SMALL ICON
 * @param param0
 * @returns
 */
// region Copy Small Icon
export const CopySmallIcon = ({ size = 16, color = "#D9D9D9" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6017_7163"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={size}
        height={size}
      >
        <rect width={size} height={size} fill={color} />
      </mask>
      <g mask="url(#mask0_6017_7163)">
        <path
          d="M6 12.0002C5.63333 12.0002 4.66667 12.0002 4.66667 12.0002C4.66667 12.0002 4.66667 11.0335 4.66667 10.6668V2.66683C4.66667 2.30016 4.66667 1.3335 4.66667 1.3335C4.66667 1.3335 5.63333 1.3335 6 1.3335H12C12.3667 1.3335 13.3333 1.3335 13.3333 1.3335C13.3333 1.3335 13.3333 2.30016 13.3333 2.66683V10.6668C13.3333 11.0335 13.3333 12.0002 13.3333 12.0002C13.3333 12.0002 12.3667 12.0002 12 12.0002H6ZM6 10.6668H12V2.66683H6V10.6668ZM3.33333 14.6668C2.96667 14.6668 2 14.6668 2 14.6668C2 14.6668 2 13.7002 2 13.3335V4.00016H3.33333V13.3335H10.6667V14.6668H3.33333Z"
          fill="#345FEA"
        />
      </g>
    </svg>
  );
};

/**
 * CHECKED SMALL ICON
 * @param param0
 * @returns
 */
// region Single Check Icon
export const SingleCheckedIcon = ({
  size = 16,
  color = "#345FEA",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.43328 13.7135L1.52661 7.80679L2.47328 6.86012L7.23328 11.6201L13.4466 2.29346L14.5533 3.03346L7.43328 13.7135Z"
        fill={color}
      />
    </svg>
  );
};

/**
 * CUSTOM SPARKLE ICON
 * @param param0
 * @returns
 */
// region Sparkles Icon
export const CustomSparklesIcon = ({
  width = 25,
  height = 24,
  color = "#fff",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask
        id="mask0_6255_106"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="url(#pattern0_6255_106)" />
      </mask>
      <g mask="url(#mask0_6255_106)">
        <rect x="0.5" width="24" height="24" fill={color} />
      </g>
      <defs>
        <pattern
          id="pattern0_6255_106"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_6255_106" transform="scale(0.0078125)" />
        </pattern>
        <image
          id="image0_6255_106"
          width="128"
          height="128"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

/**
 * DOWNLOAD ICON
 * @param param0
 * @returns
 */
// region Download Icon
export const DownloadIcon = ({
  width = 16,
  height = 17,
  color = "#345FEA",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12.3486L3 7.34863L4.4 5.89863L7 8.49863V0.348633H9V8.49863L11.6 5.89863L13 7.34863L8 12.3486ZM2 16.3486C1.45 16.3486 4.17233e-07 16.3486 4.17233e-07 16.3486C4.17233e-07 16.3486 0 14.8986 0 14.3486V11.3486H2V14.3486H14V11.3486H16V14.3486C16 14.8986 16 16.3486 16 16.3486C16 16.3486 14.55 16.3486 14 16.3486H2Z"
        fill={color}
      />
    </svg>
  );
};

/**
 * CODE ICON
 * @param param0
 * @returns
 */
// region Code Icon
export const CodeIcon = ({ width = 20, height = 13, color = "#345FEA" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12.3486L0 6.34863L6 0.348633L7.425 1.77363L2.825 6.37363L7.4 10.9486L6 12.3486ZM14 12.3486L12.575 10.9236L17.175 6.32363L12.6 1.74863L14 0.348633L20 6.34863L14 12.3486Z"
        fill={color}
      />
    </svg>
  );
};

/**
 * CLOSE ICON
 * @param param0
 * @returns
 */
// region Rounded Checked
export const RoundedCheckedIcon = ({
  size = 24,
  color = "#00AFFE",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6329_332"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6329_332)">
        <path
          d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

/**
 * UNCHECKED ICON
 * @param param0
 * @returns
 */
// region Radio Unchecked
export const RadioUnCheckedIcon = ({
  size = 24,
  color = "#E6F8FF",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6329_150"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6329_150)">
        <path
          d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

/**
 *  RADIO CHECKED ICON
 * @param param0
 * @returns
 */
// region Chat Icon
export const ChatIcon = ({ size = 24, color = "#345FEA" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6329_436"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6329_436)">
        <path
          d="M8 11C8.28333 11 8.52083 10.9042 8.7125 10.7125C8.90417 10.5208 9 10.2833 9 10C9 9.71667 8.90417 9.47917 8.7125 9.2875C8.52083 9.09583 8.28333 9 8 9C7.71667 9 7.47917 9.09583 7.2875 9.2875C7.09583 9.47917 7 9.71667 7 10C7 10.2833 7.09583 10.5208 7.2875 10.7125C7.47917 10.9042 7.71667 11 8 11ZM12 11C12.2833 11 12.5208 10.9042 12.7125 10.7125C12.9042 10.5208 13 10.2833 13 10C13 9.71667 12.9042 9.47917 12.7125 9.2875C12.5208 9.09583 12.2833 9 12 9C11.7167 9 11.4792 9.09583 11.2875 9.2875C11.0958 9.47917 11 9.71667 11 10C11 10.2833 11.0958 10.5208 11.2875 10.7125C11.4792 10.9042 11.7167 11 12 11ZM16 11C16.2833 11 16.5208 10.9042 16.7125 10.7125C16.9042 10.5208 17 10.2833 17 10C17 9.71667 16.9042 9.47917 16.7125 9.2875C16.5208 9.09583 16.2833 9 16 9C15.7167 9 15.4792 9.09583 15.2875 9.2875C15.0958 9.47917 15 9.71667 15 10C15 10.2833 15.0958 10.5208 15.2875 10.7125C15.4792 10.9042 15.7167 11 16 11ZM2 22V4C2 3.45 2 2 2 2C2 2 3.45 2 4 2H20C20.55 2 21.9859 2.01408 21.9859 2.01408C21.9859 2.01408 22 3.45 22 4V16C22 16.55 22 18 22 18C22 18 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
